<div class="modal-header-custom d-flex flex-row">
    <mat-icon (click)="close()" class="close">close</mat-icon>
</div>
<mat-dialog-content>
    <div style="color: white !important;">
        <h2 style="text-transform: uppercase;">{{ 'FAQ.INFO' | translate }}</h2>
        <h3>{{ 'PERSONAL_PROFILE.PERSONAL_PROFILE' | translate }}</h3>
        <p>{{ 'FAQ.PPROFILE_INFO' | translate }}</p>
        <h3><p>{{ 'COMPANY_PROFILE.COMPANY_PROFILE' | translate }}</p></h3>
        <p>{{ 'FAQ.CPROFILE_INFO' | translate }}</p>
        <h3><p>{{ 'VENUES.VENUES' | translate }}</p></h3>
        <p>{{ 'FAQ.VENUES_INFO' | translate }}</p>
        <h3><p>{{ 'EVENTS.EVENTS' | translate }}</p></h3>
        <p>{{ 'FAQ.EVENTS_INFO' | translate }}</p>
    </div>
</mat-dialog-content>